<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="pl-4 pr-4" [formGroup]="form1">
  <p-fieldset styleClass="p-fluid" legend="Availability Admin" [toggleable]="true" [collapsed]="true">
    <div class="p-formgrid grid">
      <div class="col-12">
        Global availability admins for Rentals United.
      </div>

      <div class="flex justify-content-end mt-3">
        @if (formErrorMessage) {
          <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
        }
        <br>
          <button pButton type="button" class="p-button-danger" label="Sync All Availability"
          (click)="onSyncAllAvailabilityClick()"></button>
        </div>
      </div>
    </p-fieldset>

    <br>

      <p-fieldset styleClass="p-fluid " legend="Select Property" [toggleable]="true" [collapsed]="false">
        <div class="p-formgrid grid">
          <div class="col-12">
            <b>Select Property</b>
          </div>

          <div class="p-field col-12 mt-3">
            <span class="p-float-label">
              <p-dropdown [options]="shortTermRentals" formControlName="shortTermRentalId"
                optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="developmentId">Select Property</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small id="developmentId-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>



          <p-divider class="col-12 mt-3 mb-3"></p-divider>

          <div class="col-12 mb-2">
            <b>View Availability</b>
          </div>

          <div class="p-field col-12 md:col-4 ">
            <span class="p-float-label">
              <p-calendar formControlName="startDate">
              </p-calendar>
              <label for="disabledays">From</label>
              @for (validation of validationMessages.startDate; track validation) {
                <span>
                  @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <p-calendar formControlName="endDate">
              </p-calendar>
              <label for="disabledays">To</label>
              @for (validation of validationMessages.endDate; track validation) {
                <span>
                  @if (form1.get('endDate').hasError(validation.type) && (form1.get('endDate').dirty || form1.get('endDate').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>


          <div class="p-field col-12">
            @if (formErrorMessage) {
              <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
            }
            <button pButton class="p-button" type="button" style="width:200px;" label="View Availability"
            (click)="onShowAvailability()"></button>
          </div>

          <p-divider class="col-12 mt-3 mb-3"></p-divider>

          <div class="col-12 mb-2">
            <b>Sync Availability</b>
          </div>
          @if (form1.value.shortTermRentalId) {
            <div class="mt-3">
              @if (formErrorMessage) {
                <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
              }
              <br>
                <button pButton type="button" label="Sync Property" (click)="onFormSubmit()"></button>
                <div> <br><br>
                  <a target="_blank" [routerLink]="['/logmans/short-term-rental', 'RU_PUSH_AVAILABILITY',this.form1.value.shortTermRentalId]"> View Logman for shortTermRentalId #{{this.form1.value.shortTermRentalId}}</a>
                </div>
              </div>
            }
          </div>
        </p-fieldset>



        <br>
          <br>

            <h2>Properties</h2>
            <p-table [value]="ruAvailabilities">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="Date">Date <p-sortIcon field="Date"></p-sortIcon>
                </th>
                <th pSortableColumn="IsBlocked">Blocked? <p-sortIcon field="IsBlocked"></p-sortIcon>
              </th>
              <th pSortableColumn="Units">Units <p-sortIcon field="Units"></p-sortIcon>
            </th>
            <th pSortableColumn="Reservations">Reservations <p-sortIcon field="Reservations"></p-sortIcon>
          </th>
          <th pSortableColumn="MinStay">MinStay <p-sortIcon field="MinStay"></p-sortIcon>
        </th>
        <th pSortableColumn="Changeover">Changeover <p-sortIcon field="Changeover"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-availability>
    <tr>
      @if (availability.IsBlocked) {
        <td style="background-color: lightgray;"> {{availability.Date}} </td>
      }
      @if (!availability.IsBlocked) {
        <td style="background-color: lightgreen;"> {{availability.Date}} </td>
      }
      <td>{{availability.IsBlocked}}</td>
      <td>{{availability.Units}}</td>
      <td>{{availability.Reservations}}</td>
      <td>{{availability.MinStay}}</td>
      <td>{{availability.Changeover}}</td>

    </tr>
  </ng-template>
</p-table>
</div>